"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var PAGE_IDENTITY = "pageIdentity";
var CLICK_EVENT_TYPE = "click";
var LINK_NAME = "RFRR Action Link";
var REFERRER = "referrer";
var PlatformAnalyticsUtility = (function () {
    function PlatformAnalyticsUtility(analytics) {
        var _this = this;
        this.getPageIdentity = function (referrerType) { return ({
            pageIdentifier: ((referrerType === utils_1.ReferrerType.TRACK_CLOSE_BANNER) ? _this.analytics.omniture.closeBannerReferrerId : _this.analytics.omniture.referrerId)
        }); };
        this.analytics = analytics;
    }
    PlatformAnalyticsUtility.prototype.getPlatformAnalyticsInstance = function (referrerType) {
        var platformAnalyticsPrimeConfig = {
            overridenMicroMessages: [{
                    schemaName: PAGE_IDENTITY,
                    messageContent: this.getPageIdentity(referrerType)
                }
            ]
        };
        var PlatformAnalytics = require("platform-analytics-prime");
        return new PlatformAnalytics(platformAnalyticsPrimeConfig);
    };
    PlatformAnalyticsUtility.prototype.appendAdobeMIDToURL = function (href) {
        return this.getPlatformAnalyticsInstance(utils_1.ReferrerType.TRACK_SUBMIT_BANNER).appendCrossDomainTrackingTo(href);
    };
    PlatformAnalyticsUtility.prototype.trackBannerAction = function (referrerType) {
        var pa = this.getPlatformAnalyticsInstance(referrerType);
        pa.collect(JSON.parse('{}'));
        pa.publish();
        pa.trackEvent({
            schemaName: REFERRER,
            messageContent: {
                referrerId: this.getPageIdentity(referrerType),
                eventType: CLICK_EVENT_TYPE,
                linkName: LINK_NAME
            }
        });
    };
    return PlatformAnalyticsUtility;
}());
exports.PlatformAnalyticsUtility = PlatformAnalyticsUtility;
//# sourceMappingURL=platform-analytics-utility.js.map